import React from 'react'
import { withOktaAuth } from "@okta/okta-react";
//import ReactMarkdown from 'react-markdown'
import {
  getContributorSection,
  setContributorSection,
} from "../../helpers/api";
import { Redirect, Link } from "react-router-dom";
import SimpleMDE from "react-simplemde-editor";
import ReactDOMServer from "react-dom/server";
import ReactMarkdown from "react-markdown";
import "easymde/dist/easymde.min.css";
import { connect } from "react-redux";
import Processing from "../misc/processing";
import { showModal } from "../../actions/modal";

class SectionEdit extends React.Component {
  state = {
    text: null,
    sectionId: null,
    id: null,
    section: null,
    saving: false,
    redirect: null,
    customOptions: {},
  };

  restore() {
    this.setState((prev) => ({
      text: prev.section.Markdown,
    }));
  }

  componentDidMount() {
    this.setState({
      id: this.props.match.params.id,
      sectionId: this.props.match.params.sectionid,
      customOptions: {
        // reference: https://www.npmjs.com/package/react-simplemde-editor#custom-preview-rendering-example
        previewRender: (text) =>
          ReactDOMServer.renderToString(<ReactMarkdown>{text}</ReactMarkdown>),
      },
    });
    getContributorSection(
      this.props.match.params.id,
      this.props.match.params.sectionid
    ).then((data) => {
      this.setState({
        section: data,
        text: data.Markdown,
      });
    });
  }

  SaveChanges = () => {
    const { section, text } = this.state;
    this.setState({
      saving: true,
    });
    setContributorSection(section, text, this.props.user)
      .then((data) => {
        data.result === true
          ? this.setState({ redirect: `/contributor/${section.ContributorID}` })
          : this.reportError(data);
      })
      .catch((err) => {
        this.reportError(err);
      });
  };

  reportError = (err) => {
    console.error(err);
    this.setState({ saving: false });
    this.props.showModal({
      error: true,
      title: "Error",
      body: "There was an error while saving. Please try again.",
    });
  };

  updateText = (value) => {
    this.setState({
      text: value,
    });
  };

  render() {
    const { user, groups, editGroups } = this.props;
    const { section, text, saving, redirect, customOptions } = this.state;
    if (redirect) {
      return <Redirect to={redirect} />;
    }
    if (!section || saving) {
      return <Processing />;
    }
    /*
            previewRender={text => (
                <ReactMarkdown source={text} />
            )}
        */
    return (
      user &&
      editGroups.some((r) => groups.indexOf(r) > -1) && (
        <React.Fragment>
          <div className="container">
            <nav className="navbar navbar-light bg-light">
              <Link
                className="navbar-brand"
                to={`/contributor/${section.ContributorID}`}
              >
                Go back
              </Link>
            </nav>
            <div className="row">
              <div className="col">
                <div className="markdown">
                  <SimpleMDE
                    value={text || section.Markdown}
                    onChange={this.updateText}
                    rows="10"
                    options={customOptions}
                  />
                  {/*
                                     options={{
                                        toolbar: [{
                                            name: "bold",
                                            action: () => {},
                                            className: "fa fa-bold",
                                            title: "Bold",
                                        },
                                        {
                                            name: "custom",
                                            action: function customFunction(editor) {
                                                let start = editor.element.selectionStart;
                                                let end = editor.element.selectionEnd;
                                                console.log(start, end)
                                            },
                                            className: "fa fa-star",
                                            title: "Custom Button",
                                        },
                                            "|" // Separator
                                            // [, ...]
                                        ]
                                    }}
                                     */}

                  <div className="row">
                    <div className="col-6"></div>
                    <div className="col-6 text-right">
                      <div className="form-group">
                        <button
                          type="button"
                          onClick={() => this.restore()}
                          className="btn btn-sm btn-light"
                        >
                          Restore Original
                        </button>{" "}
                        <Link
                          to={`/contributor/${section.ContributorID}`}
                          className="btn btn-sm btn-light"
                        >
                          Cancel & Return
                        </Link>{" "}
                        <button
                          type="button"
                          onClick={() => this.SaveChanges()}
                          className="btn btn-sm btn-success"
                        >
                          Save Changes
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                {/*<hr className="mt-1" />
                            <div className="markdown">
                                <h3 className="section-header">{section.Title}</h3>
                                <ReactMarkdown source={text || section.Markdown} />
                            </div>
                            */}
              </div>
            </div>
          </div>
        </React.Fragment>
      )
    );
  }
}

const mapStateToProps = ({ okta }) => {
  return {
    user: okta.user,
    groups: okta.groups,
    editGroups: okta.editGroups,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    showModal: (modal) => dispatch(showModal(modal)),
  };
};

export default withOktaAuth(
  connect(mapStateToProps, mapDispatchToProps)(SectionEdit)
);